module.exports = __webpack_public_path__ + "img/img-tabs-1.35cf1411.svg";